import SouthEastIcon from '@mui/icons-material/SouthEast';

export const printingTypes = [
    {id: Math.random(), type: "largeFormat", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "digitalPrinting", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "offset", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "textilePrinting", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "laserCutting", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "uVPrinting", arrow: <SouthEastIcon/>}
]